var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":_vm.alert.type || 'error',"value":_vm.alert.message != null && _vm.alert.message != '',"transition":"fab-transition"}},[_vm._v(" "+_vm._s(_vm.alert.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }